import React, {useEffect, useMemo} from 'react';
import SearchStore from 'js/store/SearchStore';
import SeoHelmet from 'js/containers/SEO/SeoHelmet';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import Container from 'js/components/Common/Container/Container';
import SaveProfileInfo from 'js/containers/Pages/Profile/SaveProfileInfo/SaveProfileInfo';

import Top from './Top/Top';
import classes from './Profile.module.pcss';
import Interests from './Interests/Interests';
import Information from './Information/Information';
import Preferences from './Preferences/Preferences';

const Profile = () => {
    const {INIT_MIX_PANEL} = useMemo(() => MixPanelWrapper, []);
    useEffect(() => {
        (async () => {
            await MixPanelWrapper.TrackPageView({
                page: 'My Profile'
            });
        })();
    }, [INIT_MIX_PANEL]);

    useEffect(() => {
        SearchStore.setSourcePage({
            name: 'My Profile',
            uri: 'profile',
            parent: null
        });
    }, []);

    return (
        <section className={classes.Profile}>
            <SeoHelmet title={'My Profile'} description={'My Profile'} canonical={'/profile'}/>
            <Container additionalClass={classes.ProfileWrap}>
                <Top/>
                <Information/>
                <Preferences/>
                <Interests/>
                <SaveProfileInfo/>
            </Container>
        </section>
    );
};

export default Profile;
